import React, { Component } from 'react'
import i18n from '../i18n.json'

class Policy extends Component {
  renderNav() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
      <div className="nav">
        <ul>
          <li className="left-corner">
            <a id="automagic-logo" href="/">
              automagic<br />.design
            </a>
          </li>
          <li>
              <a href="/">
                <div className="padding-bottom">
                  <h2><i className="fa fa-plus-square-o"></i></h2>
                  { i18n[selectedLanguage]['dashboard-menu-new-logo'] }
                </div>
              </a>
          </li>
        </ul>

      </div>
    )
  }

  renderContent() {
    return (
      <div className="fullpage">
        <div className="row">

           <div className="col-6 page-description">
            <h1>Privacy Policy</h1>
            <p>Last update: January 30th, 2018</p>
           </div>

           <div className="col-6 page-content page-terms">
      <p>
Automagic Design (or "automagic design", "Codai", "codai", "we", "us", "our") tries to collect as fewer data as possible, only with the purpose to improve the quality of our services and products to your (or "User") own benefit. We collect Personal Information about you only when you have communicated with us by email (we only collect your email address), when you create an User Account (we only collect your name and email address) and when you purchase one of our products or services we delegate the payment processor (PayPal) and we don't collect any billing or credit card information on our databases.

<h2>1. Information Safety</h2>

The information we receive from you is protected against unauthorized access once we receive it. We limit the access to your information to our own employees who have a business reason for accessing it. When collecting financial information from you, we use secure socket layer software (SSL). Despite our continual and evolving efforts to protect your personal information, we cannot guarantee the security of your Personal Information. You acknowledge and agree that we make no such guarantee.

<h2>2. Data Collected</h2>

We collect anonymous data from every visitor of automagic design's website and apps to monitor traffic, fix bugs and to develop new features and data processing. For example, we collect information like web requests, the data sent in response to such requests, the Internet Protocol address, the browser type, the browser language, and a timestamp for the request.

During the process of generating our products (like Temporary Designs or Paid Designs) we ask for information regarding your business, commercial or personal brand or project (for example, the name of your brand, your brand values or emotions associated with it) and other general preference information (for example, color palette preference, or typeface preference). We store those informations and preferences with sole intent to improve our products and services, increasing the quality of our services and products to serve you better.

<h2>3. Disclosure</h2>

We will not sell or distribute your Personal Information except to provide products or services you have requested, when we have permission, or it is necessary to share information in order to investigate, prevent, or take action regarding illegal activities, suspected fraud, situations involving potential threats to the physical safety of any person, violations of Terms of Service, or as otherwise required by law. Business transfers If automagic design, or substantially all of its assets were acquired, or in the unlikely event that we go out of business or enter bankruptcy, Personal Information would be one of the assets transferred to or acquired by a third party. You acknowledge that such transfers may occur, and that any acquirer of automagic design may continue to use the Personal Information as set forth in this policy.

<h2>4. Amendments</h2>

We may amend this Privacy Policy from time to time. Use of information we collect now is subject to the Privacy Policy in effect at the time such information is used. If we make major changes in the way we collect or use information, we will notify you by posting an announcement on automagic design's website or sending you an email. A user is bound by any changes to the Privacy Policy when he or she uses the Product after such changes have been first posted.

<h2>5. Contact</h2>

Questions on our privacy policy can be directed to contact@automagic.design.
      </p>
           </div>

        </div>
      </div>
    )
  }

  renderBottom() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
        <div>
         <div className="bottom bottom-left">
          <a href="/about">{ i18n[selectedLanguage]['bottom-about'] }</a> |
          <a href="/pricing"> { i18n[selectedLanguage]['bottom-pricing'] }</a> |
          <a href="mailto:contact@automagic.design"> { i18n[selectedLanguage]['bottom-contact'] }</a> |
          <a href="/tos"> { i18n[selectedLanguage]['bottom-tos'] }</a> |
          <a href="/privacy"> { i18n[selectedLanguage]['bottom-privacy'] }</a>
         </div>
         { /*
         <div className="bottom bottom-right">
          <a className="language-selector" href="/en" onClick={ (evt) => { evt.preventDefault(); this.props.updateLanguage('en') } }> EN</a> |
          <a className="language-selector" href="/pt" onClick={ (evt) => { evt.preventDefault(); this.props.updateLanguage('pt') } }> PT-BR</a>
         </div>
         */ }
        </div>
    )
  }

  render() {
    return (
      <div>
        { this.renderNav() }

        { this.renderContent() }

        { this.renderBottom() }
      </div>
    )
  }
}

export default Policy



// WEBPACK FOOTER //
// ./src/components/Policy.js